<template>
  <div id="PDFTemplate">
      <v-container class="pa-0 upload-css">
        <v-layout row v-if="templateEdit">
          <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="backTolisting">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
        <v-layout row v-else>
        <v-flex class="xs12 sm12 mb-5">
           <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute right @click="templateAddPage" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </v-container>  
      <v-container grid-list-md fluid v-if="!templateEdit">
      <v-card class="mt-1">
      <v-data-table
        disable-initial-sort
        :headers="pdfHeaders"
        :items="PdfTemplate"
        class="pf-data-table" 
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <tr v-if="MyAgencies">
            <td>{{ props.item.name }}</td>
            <td>{{ formatDate(props.item.createdAt) }}</td>
            <!-- <td>{{ props.item.directory }}</td> -->
            <td v-html="getAgencyNames(props.item.agency)"></td>
            <td>
              <v-select
                @input="typeUpdated($event, props.item)"
                v-model="props.item.type"
                :items="typeList"
                height="30px"
              ></v-select>
            </td>
            <td align="right">
              <v-btn icon class="ma-0" v-if="totalActiveAgencies.length !== 1 && props.item.file && props.item.file.webPath" title="Download" @click="downloadItem(props.item)">
                <v-icon size="22" color="grey darken-2">download</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-if="totalActiveAgencies.length !== 1" :disabled="((session.getSession().adminUser && session.getSession().adminUser.role === 'agency') ? true : false)" title="Agency edit" @click="editItem(props.item)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-if="session.getSession().adminUser && session.getSession().adminUser.role === 'admin'" title="Delete template" @click="deleteItem(props.item, 'admin')">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-else :disabled="((session.getSession().adminUser && session.getSession().adminUser.role === 'agency') ? true : false) || (session.role() === 'parent' && Account.flipbook && Account.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1) || (session.role() === 'child' && Child.flipbook && Child.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1)" v-on:click="deleteItem(props.item);">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      </v-card>
      </v-container>
      <v-form v-else ref="formEdit">
        <v-container>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap row>
        <v-flex class="xs12 sm6 md7">
        <v-select 
            v-model="selectAgencies" 
            @change="changedData"
            :items="unselectedAgencies" 
            attach small-chips deletable-chips 
            label="Agencies" 
            :rules="rules"
            required
            multiple
            item-text="name"
            item-value="id"
            @input="changedData"
            class="pr-4 pl-4 required">
        </v-select>
        </v-flex>
        </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
  </div>
</template>

<script>
/* global session store config */  
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import { getCollection, create, remove, requestExternal, formatDate, update } from '../helpers/helpers';
import Vue from 'vue';
import session from '../helpers/session';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';

export default {
  name: 'PDFTemplate',
  components: {
    'upload-btn': UploadButton
  }, 
  data: () => ({
    editIndex: -1,
    roleEntity: 'Account',
    templateEdit: false,
    selectedData: false,
    selectAgencies: [],
    unselectedAgencies: [],
    disabledAgencies: [],
    editableTemplate: {},
    totalActiveAgencies: [],
    AdminAgency: [],
    config: config,
    entity: 'PdfTemplate',
    typeList: ['Printer Spread', 'Reader Spread'],
    pdfHeaders: [
      { text: 'Filename', value: 'name', align: 'left' },
      { text: 'Date', sortable: false },
      // { text: 'Directory', sortable: false },
      { text: 'Agency', sortable: false, width: '200px' },
      { text: 'Type', value: 'type', width: '210px' },
      { text: '', sortable: false, width: '200px' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    rules: [
      v => (v) !== null && v.length !== 0 || 'select atleast one agency'
    ]
  }),
  computed: {
    PdfTemplate: {
      get () {
        return store.state.PdfTemplate;
      },
      set (value) {
        store.commit('setPdfTemplate', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    MyAgencies: {
      set (value) {
        store.commit('setMyAgencies', value);
      },
      get () {
        return store.state.MyAgencies;
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    await this.templateIntilize();
    if (this.PdfTemplate.length) {
      await this.initialize();
    }
    let statusList = ['Active', 'In Progress', 'Approved'];
    this.totalActiveAgencies = this[this.roleEntity].agency.filter(agency => statusList.indexOf(agency.status) > -1);
  },
  methods: {
    forceFileDownload (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    async downloadItem (item) {
      if (item.file && item.file.webPath) {
        let pdfUrl = config.uploadPath + item.file.webPath;
        let { error, data } = await requestExternal(pdfUrl, 'GET', {}, {}, 'blob');
        if (error) {
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the file'
          };
        } else {
          this.forceFileDownload(data, item.file.webPath.replace(/^.*[\\\/]/, ''));
        }

        // JSZipUtils.getBinaryContent(pdfUrl, function (err, data) {
        //   if (err) {
        //     throw err; // or handle the error
        //   }
        //   saveAs(data, item.file.webPath.substr(item.file.webPath.lastIndexOf('/') + 1));
        // });
      }
    },
    templateAddPage () {
      if (!this.totalActiveAgencies.length) {
        swal.fire({
          title: `<strong>No Active Agencies</strong>`,
          type: 'error',
          html: 'You don\'t have any agencies with Active, In Progress or Approved status to add PDF Profile',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close'
        });
      } else {
        this.$router.push({ name: 'pdfTemplateAdd', query: { preUrl: 'pdfTemplate' }});
      }
    },
    getAgencyNames (pdfAgencies) {
      if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
        if (this.AdminAgency) {
          let list = this.AdminAgency.filter(agency => pdfAgencies.indexOf(agency.id) !== -1);
          return list.map(agency => agency.name).join(', <br/>');
        }
      } else {
        let list = this.MyAgencies.filter(agency => pdfAgencies.indexOf(agency.id) !== -1);
        return list.map(agency => agency.name).join(', <br/>');
      }
    },
    avaliableAgencies () {
      if (this.PdfTemplate.length) {

        let activeAgencies = Array.from(this.totalActiveAgencies, row => row.agency);

        let selectedAgenciesNotWithCurrentTemp = this.PdfTemplate.filter(template => template.id !== this.editableTemplate.id);
        let selectedAgencies = selectedAgenciesNotWithCurrentTemp.map(template => template.agency);
        let agenciesIds = selectedAgencies.flat();

        this.unselectedAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1 && agenciesIds.indexOf(agency.id) === -1);
        this.disabledAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1 && agenciesIds.indexOf(agency.id) !== -1);

        this.disabledAgencies = this.disabledAgencies.map(agency => ({ ...agency, disabled: true }));
        this.unselectedAgencies = [...this.unselectedAgencies, ...this.disabledAgencies];
      }
      this.selectAgencies = [...this.editableTemplate.agency];
    },
    async templateIntilize () {
      // Initialize PDF templates
      if (!this.PdfTemplate.length) {
        let sessionUser = session.getSession();
        let where = { active: true };
        if (sessionUser.adminUser) {
          where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
        }
        let { error, data, status } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load PdfTemplates'
          };
        } else {
          this[this.entity] = data.filter(pdf => {
            if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
              return pdf.agency.findIndex(agency => agency === session.getSession().adminUser.human.agency || (session.getSession().adminUser.human.agency.id && agency === session.getSession().adminUser.human.agency.id)) !== -1;
            }
            return true;
          });
        }
      }
    },
    async initialize () {
      if (!this.MyAgencies.length) {
        let where = {};
        if (this.roleEntity === 'Child') {
          where['child.child'] = this.Child.id;
        } else {
          where['account.account'] = this.Account.id;
        }
        let attributes = 'name,createdAt,account,child,_id';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.MyAgencies = data;
            if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
              this.getAdminAgency();
            }
          }
        }
      } else {
        if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') this.getAdminAgency();
      }
    },
    getAdminAgency () {
      this.AdminAgency = this.MyAgencies.filter(agency => agency.id === session.getSession().adminUser.human.agency);
    },
    formatDate (dateString) {
      return formatDate(dateString, 'MM/DD/YYYY');
    },
    deleteItem (item, userType = 'parent') {
      let textMsg = '';
      if (item.agency.length === 1) {
        textMsg = `You won't be able to revert this!`;
      } else {
        textMsg = 'PDF will be deleted from all the agencies assigned. Please confirm whether to proceed?';
      }
      swal.fire({
        title: 'Are you sure?',
        text: textMsg,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              // Create the timeline
              let timelineData = {
                title: 'Profile PDF Deleted',
                text: `You've deleted a profile PDF - '${item.name}'`
              };
              timelineData[this.roleEntity.toLowerCase()] = this[this.roleEntity].id;

              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                const index = this[this.entity].indexOf(item);
                this[this.entity].splice(index, 1);
                if (userType === 'admin') {
                  let deletedItem = this[this.roleEntity].flipbook.find(flipbook => flipbook.pdf_template === item.id);
                  this[this.roleEntity].flipbook.splice(this[this.roleEntity].flipbook.indexOf(deletedItem), 1);
                  this[this.roleEntity] = this[this.roleEntity];
                }
                swal.fire(
                  'Deleted!',
                  'The PDF template "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            }
          })();
        }
      });
    },
    async typeUpdated (event, item) {
      let editData = Object.assign({}, item);
      let { error, data } = await update(this.entity, editData, editData.id);
      if (error) {
        console.log('error', error);
      } else {
        let editIndex = this.PdfTemplate.indexOf(item);
        this.PdfTemplate[editIndex] = data;
        this.loading = false;
        swal.fire({
          type: 'success',
          title: 'Type updated successfully',
          showConfirmButton: false,
          timer: 2500
        });
      }
    },
    // @vuese
    // Used to go back to the pdfTemplate listing from edit page
    backTolisting () {
      this.templateEdit = false;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },
    async editItem (item) {
      this.editableTemplate = { ...item };
      await this.avaliableAgencies();
      if (!this.unselectedAgencies.length) {
        swal.fire({
          title: `<strong>No Active Agencies</strong>`,
          type: 'error',
          html: 'You don\'t have any agencies with Active, In Progress or Approved status to edit PDF Profile',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close'
        });
      } else {
        this.templateEdit = true;
        this.editIndex = this.PdfTemplate.indexOf(item);
        window.getApp.$emit('pageSubHeader', 'Edit');
      }
    },
    async save () {
      if (this.$refs.formEdit.validate() && this.editIndex > -1) {
        this.selectedData = false;
        let { error, data, status } = await update('PdfTemplate', { agency: this.selectAgencies }, this.editableTemplate.id);
        if (error) {
          console.log('error', error);
          this.selectedData = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.PdfTemplate[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Template updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.templateEdit = false;
              this.selectedData = false;
              this.editableTemplate = {};
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
  }
};
</script>
<style scoped>
  .custom-mt {
    margin-top: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/PDFTemplate.vue